import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { ButtonGroup } from '@material-ui/core';
import { Add, Ballot, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import CardTable from '../../components/CardTable/CardTable';
import RegularButton from '../../components/CustomButtons/Button';
import { ModalV2 } from '../../components/Modal/ModalV2';
import SelectDateMenu from '../../components/SelectDateMenu/SelectDateMenu';
import Snackbars from '../../components/Snackbar/Snackbar.js';
import { FormContractConditionEdit } from './FormContractConditionsEdit';
import { columns1, columns2 } from './columns';
import { 
  resetContractConditionSelected,
  addContractConditionMode,
  getContractsConditionsData,
  getContractsConditions,
  clearContractsConditions,
  clearOnlyContractsConditions,
} from '../../redux/actions/contractsConditionsCatalog/contractsConditionsCatalogActions';
import { getAllContracts } from '../../redux/actions/contractsCatalog/contractsCatalogActions';
import { convertToMapById } from '../../helpers/convertToMap';
import { useOpenComponent } from '../../hooks/useOpenComponent';
import { useSearch } from '../../hooks/useSearch';

export const ContractsConditionsCatalog = () => {
  const { 
    changeStation, 
    setSnackbar, 
    clearSnackbar, 
    clearSearch
  } = useSearch();

  const { token } = useSelector(state => state.login);
  const { contractsConditionsArr, addContractCondition } = useSelector(state => state.contractsConditionsCatalog);
  const { stationsSelected, color, message, isOpen: isSnackbarOpen, isLoading } = useSelector((state) => state.search);
  const { stations } = useSelector(state => state.companies);
  const { isOpen, handleIsOpen } = useOpenComponent();
  const [mapContractsConditions, setContractsConditions] = useState([]);
  const [mapStations, setMapStations] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [columns, setColumns] = useState(columns1);
  const dispatch = useDispatch();

  const fetchContracts = useCallback(
    ( token, stationID ) => {
      dispatch(getContractsConditions( token, stationID ));
    },
    [dispatch]
  );

  const handleSubmit = useCallback(() => {
    if (stationsSelected.length < 1) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    const stationID = stationsSelected.id
    fetchContracts( token, stationID );
    setSubmitted(true);
  }, [token, stationsSelected, setSnackbar, fetchContracts]);

  const handleClose = () => {
    dispatch(resetContractConditionSelected());
    handleIsOpen();
  };
  
  const handleOpenAdd = () => {
    dispatch(addContractConditionMode());
    handleIsOpen();
  };

  const submitMemoized = useCallback(() => {
    handleSubmit();
  }, [handleSubmit]);

  // Effects
  useEffect(() => {
    dispatch(clearOnlyContractsConditions());
  }, [stationsSelected, dispatch]);

  useEffect(() => {
    dispatch(clearContractsConditions());
    clearSearch();
    dispatch(getAllContracts(token));
    dispatch(getContractsConditionsData(token));
  }, [dispatch, clearSearch, token]);

  useEffect(() => {    
    setContractsConditions(
      contractsConditionsArr?.map(contract => {
        return {
          ...contract,
          modal: handleIsOpen,
        };
      }).flat()
    );
    // eslint-disable-next-line
  }, [contractsConditionsArr]);

  useEffect(() => {
    setMapStations( convertToMapById(stations) );
  }, [stations]);

  useEffect(() => {
    const isEmpty = mapContractsConditions.length === 0
    if (isEmpty && submitted) {
      setSnackbar("No se encontraron condiciones de contrato");
    }
    setSubmitted(false);
    // eslint-disable-next-line
  }, [mapContractsConditions])
  
  return (
    <React.Fragment>
      <SelectDateMenu
        isMultiOne={false}
        stations={mapStations}
        optionSelected={stationsSelected}
        disabled={isLoading}
        color="info"
        hasStations
        onlyStations
        onChangeFilter={changeStation}
        onSubmit={submitMemoized}
      />
      <CardTable
        data={mapContractsConditions}
        columns={columns}
        loading={isLoading}
        hasHeader
        title={"Catálogo de Condiciones de Contratos"}
        icon={<Ballot />}
        blockBtn
        hasControl
        controls={
          <>
            <ButtonGroup>
              <RegularButton color="info" tooltip='Tabla parte 1' style={{ marginTop: 10, marginBottom: 10 }} round size='sm' onClick={() => {
                  setColumns(columns1)
                }
              }>
                <KeyboardArrowLeft style={{ margin: 0 }} />
              </RegularButton>
              <RegularButton color="info" tooltip='Tabla parte 2' style={{ marginTop: 10, marginBottom: 10 }} round size='sm' onClick={() => {
                  setColumns(columns2)
                }
              }>
                <KeyboardArrowRight style={{ margin: 0 }} />
              </RegularButton>
            </ButtonGroup>
            {
              addContractCondition && (
                <RegularButton round justIcon color="info" style={{ margin: 10 }} onClick={handleOpenAdd}>
                  <Add style={{ margin: 0 }}/>
                </RegularButton>
              )
            }
          </>
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
      >
        <FormContractConditionEdit handleClose={handleClose} stations={mapStations}/>
      </ModalV2>

      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isSnackbarOpen}
        closeNotification={clearSnackbar}
        close
      /> 
    </React.Fragment>
  )
}
